import { Controller } from "@hotwired/stimulus"

// Cornerstone spike: gives a <cs-color-picker> the Cru palette hues as swatches, read from
// the theme's own tokens (--cs-color-<hue>-<tint>) so the palette has one source of truth.
// The picker's swatches take real colors, not var() references, so the tokens are resolved
// here, and set as { color, label } objects so each swatch is named for its hue.
//
// Markup: <cs-color-picker data-controller="palette-swatches"
//   data-palette-swatches-hues-value="cyan green …" data-palette-swatches-tint-value="90">
export default class extends Controller {
  static values = { hues: String, tint: { type: String, default: "90" } }

  connect() {
    const styles = getComputedStyle(document.documentElement)
    this.element.swatches = this.huesValue.split(/\s+/).filter(Boolean).flatMap((hue) => {
      const color = styles.getPropertyValue(`--cs-color-${hue}-${this.tintValue}`).trim()
      return color ? [{ color, label: hue.charAt(0).toUpperCase() + hue.slice(1) }] : []
    })
  }
}
